// extracted by mini-css-extract-plugin
export var activityContainer = "_ld-0";
export var typingIndicatorContainer = "_ld-1";
export var typingIndicatorDot = "_ld-2";
export var wave = "_ld-3";